<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container fluid v-if="relatedArticles && relatedArticles.length > 0">
        <b-row class="mt-5">
            <b-col class="text-center">
                <h3 class="center-line">RELATED ARTICLES
                    <hr/>
                </h3>
                <b-row align-h="center">
                    <b-col>
                        <pb-carousel>
                            <router-link class="card-deck my-3 mr-3" :key="article.id + category.id"
                                         v-for="(article) in relatedArticles"
                                         :to="{ name: 'ar', params: { articleId: article.id, categoryId: (article.userCategoryList.length > 0 && article.userCategoryList.indexOf(category.id) > -1) ? category.id : article.primaryCategory, variantId: null}}">
                                <pb-card class="related-article-card"
                                         :img-src="article.webImage || article.image">
                                    <template slot="image">
                                        <div v-if="article.variantList.some(a => a.neverOutOfStock)" class="nos-img"></div>
                                        <img :src="imageResource((article.webImage || article.image), 240)"
                                             alt="thumbnail"/>
                                    </template>
                                    <template slot="content">
                                        <span class="d-block">{{article.primaryDescription || article.secondaryDescription}}</span>
                                        <span class="d-block"><small>{{article.name}}</small></span>
                                    </template>
                                </pb-card>
                            </router-link>
                        </pb-carousel>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import ArticleApi from "@shared/_api/article";
    import {mapState} from "vuex";

    export default {
        name: 'pb-related-articles',
        data: function () {
            return {
                relatedArticleList: []
            }
        },
        mounted() {
            let relatedArticleFunction = this.user ? ArticleApi.customerRelatedList : ArticleApi.relatedList;

            return relatedArticleFunction(this.article.id).then((articleList) => {
                this.relatedArticleList = articleList;
            });
        },
        computed: {
            ...mapState("account", ['user']),
            relatedArticles: function () {
                return this.relatedArticleList.filter(article => article.webImage);
            }
        },
        props: {
            id: {
                type: String
            },
            article: {
                type: Object
            },
            category: {
                type: Object
            }
        }
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .related-article-card {
        width: 275px;
    }

    .tns-ovh {
        padding: 20px 0 !important;
    }

</style>
